/**
 * @param {*} state
 * @param {*} payload
 */
export const retrieveJadlogAgencies = (state, payload) => {
  state.jadlogAgencies = payload
}

/**
 * @param {*} state
 * @param {*} data
 */
export const updateFilters = (state, data) => {
  switch (data.type) {
    case 'client':
      state.filters.client = data.value
      break;

    case 'limit':
      state.filters.limit = data.value
      break;

    case 'range':
      state.filters.range = data.value
      break;

    case 'page':
      state.filters.page = data.value
      break;

    default:
      state.filters.search = data.value
      break;
  }
}

/**
 * @param {*} state
 */
export const changeModalStatus = (state) => {
  state.modalOpenFlag = !state.modalOpenFlag;
}

/**
 * @param {*} state
 */
export const changeSidebarStatus = (state, payload) => {
  state.sidebarOpen = payload;
}
